<div class="d-flex align-items-center">
  <div class="bullet-with-text rounded-circle" [style.color]="color" [style.border]="'1px solid ' + color">
    {{ index + 1 }}
  </div>
</div>
